module.exports = __webpack_public_path__ + "media/images/login-bgr-547738d50effb003deaae290fe540cf6.jpg";